import React from "react";

import DasboardHeader from "./component";
import { useHistory } from "react-router-dom";

interface HeaderProps {
  selector: any | null;
  title: string;
  withRating: boolean;
  withScoreBoard: boolean;
}
const DasboardHeaderContainer: React.FC<HeaderProps> = ({
  title,
  selector,
  withRating,
  withScoreBoard,
}) => {

  const history = useHistory();
  const handleRoute = () => history.push("/");

  const childProps = {
    title,
    handler: handleRoute,
    selector,
    withRating,
    withScoreBoard,
  };

  return (<DasboardHeader {...childProps} />);
};

export default DasboardHeaderContainer;
